module.exports = __webpack_public_path__ + "assets/handshake.d8c9abce.svg";